export enum LookerMemberManagementDashboardType {
  Member_Management = 655,
  Membership_History = 659,
  Enrollment_Oversight_Dashboard = 712,
  Disenrollment_Oversight_Dashboard = 843,
  Correspondence_Oversight_Dashboard = 886,
  Billing_Oversight_Dashboard = 736,
  CMS_Transaction_Reply_Report = 756,
  Member_Status_Roster = 776,
  PaymentAdjustmentDashboardDW = 786,
  MemberAddress = 803,
  BenefitConfigurationDashboard = 804,
  PartCMspOhiDW = 826,
  PartDCobOhiDW = 872,
  Reconciliation_Capitation_Report = 927,
  Work_Queue_Dashboard = 931,
  User_Mgmt_Dashboard = 961,
  Error_Review_Dashboard = 988,
  Invoice_Aging_Report = 1018,
  Bill_Detail_Report = 1044,
}
